/* =========================================================================
   SARTE Leather — UI layer
   Preloader, header, hero slider, rails, reviews slider, counters,
   parallax, process line, tilt, footer accordion, forms, back-to-top,
   word reveals. Re-initialises on Theme Editor section load.
   ========================================================================= */
(function () {
  'use strict';
  var d = document, w = window;
  var reduced = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouch = w.matchMedia && w.matchMedia('(hover: none)').matches;
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function once(el, key) { key = 'sarte' + key; if (el.dataset[key]) return true; el.dataset[key] = '1'; return false; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function raf(fn) { var t = false; return function () { if (t) return; t = true; requestAnimationFrame(function () { t = false; fn(); }); }; }

  /* ---------- Preloader ---------- */
  function initPreloader() {
    var pre = $('[data-sarte-preloader]');
    if (!pre) return;
    var oncePerSession = d.body.getAttribute('data-preloader-once') === 'true';
    var seen = false;
    try { seen = oncePerSession && sessionStorage.getItem('sarte_preloaded') === '1'; } catch (e) {}
    if (seen || reduced) { pre.remove(); return; }
    d.body.classList.add('sarte-loading');
    var dur = parseInt(pre.getAttribute('data-duration'), 10) || 1400;
    var start = Date.now();
    function finish() {
      var wait = Math.max(0, dur + 350 - (Date.now() - start));
      setTimeout(function () {
        pre.classList.add('is-done');
        d.body.classList.remove('sarte-loading');
        try { if (oncePerSession) sessionStorage.setItem('sarte_preloaded', '1'); } catch (e) {}
        setTimeout(function () { pre.remove(); revealNow(); }, 800);
      }, wait);
    }
    if (d.readyState === 'complete') finish(); else w.addEventListener('load', finish, { once: true });
    setTimeout(finish, dur + 2500); // safety net
  }

  /* ---------- Reveal (headings + fallback for .reveal) ---------- */
  var revealIO = null;
  function revealNow() {
    $$('.sarte-heading, .reveal, .reveal-stagger, .sarte-step').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < w.innerHeight * 0.92 && r.bottom > 0) el.classList.add('is-visible');
    });
  }
  function initReveal(scope) {
    var els = $$('.sarte-heading, .reveal, .reveal-stagger, .sarte-step', scope);
    if (reduced || !('IntersectionObserver' in w)) { els.forEach(function (el) { el.classList.add('is-visible'); }); return; }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); revealIO.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    }
    els.forEach(function (el) { if (el.closest('.sarte-hero__slide')) return; if (!once(el, 'Reveal')) revealIO.observe(el); });
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var header = $('.site-header');
    if (!header || once(header, 'Hdr')) return;
    var progress = $('[data-scroll-progress]', header);
    var hideOn = d.body.classList.contains('sarte-header-hide');
    var last = w.pageYOffset, hidden = false;
    var update = raf(function () {
      var y = w.pageYOffset;
      header.classList.toggle('is-scrolled', y > 24);
      if (progress) {
        var h = d.documentElement.scrollHeight - w.innerHeight;
        progress.style.setProperty('--p', h > 0 ? clamp(y / h, 0, 1) : 0);
      }
      if (hideOn) {
        var down = y > last && y > 260 && !d.body.classList.contains('drawer-open');
        if (down !== hidden) { hidden = down; header.classList.toggle('is-hidden', hidden); }
      }
      last = y;
    });
    w.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ---------- Hero slider ---------- */
  function initHero(hero) {
    if (once(hero, 'Hero')) return;
    var slides = $$('[data-slide]', hero), dots = $$('[data-dot]', hero);
    var counter = $('[data-current]', hero), prev = $('[data-prev]', hero), next = $('[data-next]', hero);
    var auto = hero.getAttribute('data-autoplay') === 'true' && !reduced && slides.length > 1;
    var interval = parseInt(hero.getAttribute('data-interval'), 10) || 6000;
    var i = 0, timer = null, paused = false;
    hero.style.setProperty('--hero-interval', interval + 'ms');
    if (slides.length) slides[0].classList.add('is-visible');
    function go(n, user) {
      if (!slides.length) return;
      n = (n + slides.length) % slides.length;
      if (n === i && slides[n].classList.contains('is-active') && user === undefined) return;
      slides[i].classList.remove('is-active');
      dots[i] && dots[i].classList.remove('is-active');
      i = n;
      var s = slides[i];
      s.classList.remove('is-visible');
      // restart word reveal
      $$('.sarte-heading', s).forEach(function (h) { h.classList.remove('is-visible'); });
      void s.offsetWidth;
      s.classList.add('is-active');
      requestAnimationFrame(function () { s.classList.add('is-visible'); $$('.sarte-heading', s).forEach(function (h) { h.classList.add('is-visible'); }); });
      dots[i] && dots[i].classList.add('is-active');
      if (counter) counter.textContent = ('0' + (i + 1)).slice(-2);
      if (user) restart();
    }
    function tick() { if (!paused && !d.hidden) go(i + 1); }
    function restart() { if (!auto) return; clearInterval(timer); timer = setInterval(tick, interval); }
    dots.forEach(function (b, n) { b.addEventListener('click', function () { go(n, true); }); });
    prev && prev.addEventListener('click', function () { go(i - 1, true); });
    next && next.addEventListener('click', function () { go(i + 1, true); });
    if (!isTouch) {
      hero.addEventListener('mouseenter', function () { paused = true; hero.classList.add('is-paused'); });
      hero.addEventListener('mouseleave', function () { paused = false; hero.classList.remove('is-paused'); restart(); });
    }
    var sx = 0, sy = 0;
    hero.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4) go(dx < 0 ? i + 1 : i - 1, true);
    }, { passive: true });
    hero.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') go(i + 1, true); if (e.key === 'ArrowLeft') go(i - 1, true); });
    // in Theme Editor: jump to selected block
    d.addEventListener('shopify:block:select', function (e) {
      var idx = slides.indexOf(e.target); if (idx > -1 && hero.contains(e.target)) { go(idx, true); paused = true; }
    });
    d.addEventListener('shopify:block:deselect', function (e) { if (hero.contains(e.target)) { paused = false; restart(); } });
    restart();
    // make first heading visible immediately (hero is above the fold)
    $$('.sarte-heading', slides[0] || hero).forEach(function (h) { h.classList.add('is-visible'); });
  }

  /* ---------- Horizontal rail (categories) ---------- */
  function initRail(root) {
    if (once(root, 'Rail')) return;
    var rail = $('[data-rail]', root); if (!rail) return;
    var btns = $$('[data-scroll]', root);
    function step() {
      var c = rail.firstElementChild;
      return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || 22) : 320;
    }
    function move(dir) {
      var max = Math.max(0, rail.scrollWidth - rail.clientWidth);
      var target = rail.scrollLeft + (step() * dir);
      target = Math.max(0, Math.min(max, target));
      rail.scrollTo({ left: target, behavior: 'smooth' });
    }
    btns.forEach(function (b) {
      b.removeAttribute('disabled');
      b.addEventListener('click', function () {
        move(parseInt(b.getAttribute('data-scroll'), 10) || 0);
      });
    });
    var upd = raf(function () {
      var max = Math.max(0, rail.scrollWidth - rail.clientWidth);
      btns.forEach(function (b) {
        var dir = parseInt(b.getAttribute('data-scroll'), 10);
        var atStart = rail.scrollLeft <= 2;
        var atEnd = rail.scrollLeft >= max - 2;
        b.disabled = false;
        if (dir < 0) {
          b.setAttribute('aria-disabled', atStart ? 'true' : 'false');
        } else {
          b.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
        }
      });
    });
    rail.addEventListener('scroll', upd, { passive: true });
    w.addEventListener('resize', upd);
    upd();
    enableDrag(rail);
  }
  function enableDrag(track) {
    if (isTouch) return;
    var down = false, startX = 0, startL = 0, moved = false;
    track.addEventListener('mousedown', function (e) { down = true; moved = false; startX = e.pageX; startL = track.scrollLeft; track.classList.add('is-dragging'); });
    w.addEventListener('mousemove', function (e) { if (!down) return; var dx = e.pageX - startX; if (Math.abs(dx) > 4) moved = true; track.scrollLeft = startL - dx; });
    w.addEventListener('mouseup', function () { if (!down) return; down = false; track.classList.remove('is-dragging'); });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* ---------- Reviews slider ---------- */
  function initReviews(root) {
    if (once(root, 'Rev')) return;
    var track = $('[data-track]', root); if (!track) return;
    var slides = $$('[data-slide]', track), prev = $('[data-prev]', root), next = $('[data-next]', root), prog = $('[data-progress]', root);
    var auto = root.getAttribute('data-autoplay') === 'true' && !reduced;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var timer = null, hover = false;
    function slideW() { var s = slides[0]; return s ? s.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 22) : 300; }
    function perView() { return Math.max(1, Math.round(track.clientWidth / slideW())); }
    function goBy(n) { var max = track.scrollWidth - track.clientWidth; var target = track.scrollLeft + slideW() * n; var tol = Math.max(40, slideW() * 0.2); if (n > 0 && track.scrollLeft >= max - tol) target = 0; if (n < 0 && track.scrollLeft <= tol) target = max; track.scrollTo({ left: target, behavior: 'smooth' }); }
    prev && prev.addEventListener('click', function () { goBy(-1); restart(); });
    next && next.addEventListener('click', function () { goBy(1); restart(); });
    var upd = raf(function () {
      if (!prog) return;
      var max = track.scrollWidth - track.clientWidth;
      var visible = clamp(perView() / slides.length, .12, 1);
      prog.style.setProperty('--w', (visible * 100) + '%');
      prog.style.setProperty('--x', max > 0 ? ((track.scrollLeft / max) * (1 / visible - 1) * 100) + '%' : '0%');
    });
    track.addEventListener('scroll', upd, { passive: true }); w.addEventListener('resize', upd); upd();
    function restart() { if (!auto) return; clearInterval(timer); timer = setInterval(function () { if (!hover && !d.hidden) goBy(1); }, interval); }
    root.addEventListener('mouseenter', function () { hover = true; }); root.addEventListener('mouseleave', function () { hover = false; restart(); });
    track.addEventListener('touchstart', function () { hover = true; }, { passive: true }); track.addEventListener('touchend', function () { hover = false; restart(); }, { passive: true });
    enableDrag(track);
    if ('IntersectionObserver' in w) {
      new IntersectionObserver(function (en) { if (en[0].isIntersecting) restart(); else clearInterval(timer); }, { threshold: .2 }).observe(root);
    } else restart();
  }

  /* ---------- Counters ---------- */
  function initCounters(scope) {
    var els = $$('[data-counter]', scope); if (!els.length) return;
    function run(el) {
      var to = parseFloat(el.getAttribute('data-to')) || 0, dec = parseInt(el.getAttribute('data-decimals'), 10) || 0;
      var prefix = el.getAttribute('data-prefix') || '', suffix = el.getAttribute('data-suffix') || '';
      if (reduced) { el.textContent = prefix + to.toFixed(dec) + suffix; return; }
      var t0 = null, dur = 1600;
      function frame(t) { if (!t0) t0 = t; var p = clamp((t - t0) / dur, 0, 1); var e = 1 - Math.pow(1 - p, 3); el.textContent = prefix + (to * e).toFixed(dec) + suffix; if (p < 1) requestAnimationFrame(frame); }
      requestAnimationFrame(frame);
    }
    if (!('IntersectionObserver' in w)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } }); }, { threshold: .4 });
    els.forEach(function (el) { if (!once(el, 'Cnt')) io.observe(el); });
  }

  /* ---------- Parallax + process line ---------- */
  var pxEls = [], bgEls = [], lines = [];
  function collectParallax() {
    pxEls = reduced ? [] : $$('[data-parallax]'); bgEls = reduced ? [] : $$('[data-parallax-bg]'); lines = $$('[data-progress-line]');
  }
  var onScroll = raf(function () {
    var vh = w.innerHeight;
    pxEls.forEach(function (el) {
      var r = el.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return;
      var f = parseFloat(el.getAttribute('data-parallax')) || .08;
      var c = (r.top + r.height / 2 - vh / 2);
      var img = el.tagName === 'IMG' ? el : ($('img', el) || el);
      img.style.transform = 'translate3d(0,' + (-c * f).toFixed(1) + 'px,0)' + (el.getAttribute('data-parallax-scale') ? ' scale(1.1)' : '');
    });
    bgEls.forEach(function (el) {
      var p = el.parentElement, r = p.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return;
      var prog = (vh - r.top) / (vh + r.height);
      el.style.transform = 'translate3d(0,' + ((prog - .5) * r.height * .24).toFixed(1) + 'px,0)';
    });
    lines.forEach(function (el) {
      var list = el.closest('.sarte-process__list') || el.parentElement.parentElement; var r = list.getBoundingClientRect();
      var p = clamp((vh * .7 - r.top) / r.height, 0, 1);
      el.style.setProperty('--h', (p * 100).toFixed(1) + '%');
    });
  });

  /* ---------- Tilt ---------- */
  function initTilt(scope) {
    if (isTouch || reduced) return;
    $$('[data-tilt]', scope).forEach(function (el) {
      if (once(el, 'Tilt')) return;
      var inner = $('.sarte-split__media, .sarte-tilt__inner', el) || el;
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect(); var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        inner.style.transition = 'transform .15s ease-out';
        inner.style.transform = 'perspective(1200px) rotateX(' + (-y * 3).toFixed(2) + 'deg) rotateY(' + (x * 3).toFixed(2) + 'deg) scale(1.02)';
      });
      el.addEventListener('mouseleave', function () { inner.style.transition = 'transform .8s cubic-bezier(.16,1,.3,1)'; inner.style.transform = ''; });
    });
  }

  /* ---------- Footer accordion (mobile) ---------- */
  function initFooter(scope) {
    $$('[data-footer-toggle]', scope).forEach(function (h) {
      if (once(h, 'Ft')) return;
      h.addEventListener('click', function () {
        if (w.innerWidth > 749) return;
        var col = h.closest('.footer-col'); if (!col || col.classList.contains('sarte-footer__news')) return;
        var open = col.classList.toggle('is-open');
        h.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- Forms ---------- */
  function initForms(scope) {
    $$('[data-sarte-form], [data-sarte-newsletter]', scope).forEach(function (form) {
      if (once(form, 'Form')) return;
      form.addEventListener('submit', function () {
        if (!form.checkValidity || form.checkValidity()) {
          var b = $('[data-submit]', form); if (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); }
        }
      });
      $$('.sarte-field input, .sarte-field textarea', form).forEach(function (inp) {
        if (inp.getAttribute('placeholder') === null) inp.setAttribute('placeholder', ' ');
      });
    });
    var ok = $('[data-success]:not(:empty)');
    if (ok && (location.search.indexOf('contact_posted=true') > -1 || location.search.indexOf('customer_posted=true') > -1)) {
      setTimeout(function () { ok.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' }); }, 250);
    }
  }

  /* ---------- Back to top ---------- */
  function initToTop() {
    var b = $('[data-sarte-totop]'); if (!b || once(b, 'Top')) return;
    var upd = raf(function () {
      var y = w.pageYOffset, h = d.documentElement.scrollHeight - w.innerHeight;
      b.classList.toggle('is-visible', y > 600);
      b.style.setProperty('--p', h > 0 ? clamp(y / h, 0, 1).toFixed(3) : 0);
    });
    w.addEventListener('scroll', upd, { passive: true }); upd();
    b.addEventListener('click', function () { w.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' }); });
  }

  /* ---------- Marquee: duplicate groups to fill wide screens ---------- */
  function initMarquee(scope) {
    $$('.sarte-marquee__track', scope).forEach(function (t) {
      if (once(t, 'Mq')) return;
      var g = t.firstElementChild; if (!g) return;
      var guard = 0;
      while (t.scrollWidth < w.innerWidth * 2.2 && guard < 6) { t.appendChild(g.cloneNode(true)); guard++; }
      if (t.children.length % 2) t.appendChild(g.cloneNode(true));
    });
  }

  /* ---------- Retype (typewriter) headings — Our Craft section ---------- */
  var retypeDone = 'data-retype-done';
  function typeEl(el) {
    var full = el.getAttribute('data-retype-text') || '';
    var target = el.querySelector('[data-retype-target]');
    if (!target) return;
    var section = el.closest('[data-craft-retype]');
    var speed = section ? (parseInt(section.getAttribute('data-craft-retype'), 10) || 55) : 55;
    if (reduced) { target.textContent = full; el.classList.add('is-typed'); return; }
    var i = 0;
    el.classList.add('is-typing');
    (function tick() {
      target.textContent = full.slice(0, i);
      i++;
      if (i <= full.length) { setTimeout(tick, speed); }
      else { el.classList.remove('is-typing'); el.classList.add('is-typed'); }
    })();
  }
  function initRetype(scope) {
    $$('.sarte-retype', scope).forEach(function (el) {
      if (el.hasAttribute(retypeDone)) return;
      el.setAttribute(retypeDone, '1');
      if (!('IntersectionObserver' in w) || reduced) { typeEl(el); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { typeEl(el); io.unobserve(el); } });
      }, { threshold: 0.4 });
      io.observe(el);
    });
  }

  function initAll(scope) {
    scope = scope || d;
    initHeader();
    $$('[data-sarte-hero]', scope).forEach(initHero);
    $$('[data-sarte-cats]', scope).forEach(initRail);
    $$('[data-sarte-reviews]', scope).forEach(initReviews);
    initCounters(scope); initTilt(scope); initFooter(scope); initForms(scope); initMarquee(scope); initReveal(scope);
    collectParallax(); onScroll(); initToTop(); initRetype(scope); }
  function ready(fn) { if (d.readyState !== 'loading') fn(); else d.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    initPreloader();
    initAll();
    w.addEventListener('scroll', onScroll, { passive: true });
    w.addEventListener('resize', raf(function () { collectParallax(); onScroll(); }));
    w.addEventListener('load', function () { revealNow(); onScroll(); });
    setTimeout(revealNow, 900);
  });
  d.addEventListener('shopify:section:load', function (e) { initAll(e.target); setTimeout(revealNow, 50); });
  d.addEventListener('shopify:section:select', function (e) { $$('.sarte-heading, .reveal, .reveal-stagger, .sarte-step', e.target).forEach(function (el) { el.classList.add('is-visible'); }); });
})();
